module.exports = __webpack_public_path__ + "img/DFW_GoldSword.a30945e5.png";